// extracted by mini-css-extract-plugin
export default {"badge":"style_badge__7ocPD","icon":"style_icon__oaWSM","text":"style_text__NsjlV"};